import produce from 'immer'
import { Reducer } from 'redux'
import { UserServiceActionTypes } from '../User'
import { Action, ActionType, State } from './Library.types'

export const libraryInitialState: State = {
  libraryContent: {
    recommendedContent: null,
    shelves: []
  },
  shouldRefetchLibrary: false,
  timeSpent: 0,
  dailyGoal: 10,
  isDailyGoalAchieved: false
}

export const libraryReducer: Reducer<State, Action> = (state = libraryInitialState, action): State =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActionType.GetLibrary:
        draft.libraryContent = action.libraryContent
        // Set shouldRefetchLibrary to false as this flag indicates the need to do what we just did:
        draft.shouldRefetchLibrary = false
        return

      case ActionType.UpdateSectionEntries:
        draft.libraryContent = {
          ...draft.libraryContent,
          shelves: draft.libraryContent.shelves.map((shelf) => ({
            ...shelf,
            sections: shelf.sections.map((section) =>
              section.id === action.sectionId
                ? {
                    ...section,
                    entries: [...section.entries, ...action.newSectionPage.entries],
                    page: action.newSectionPage.page
                  }
                : section
            )
          }))
        }
        return

      case ActionType.SetShouldRefetchLibrary:
        draft.shouldRefetchLibrary = action.shouldRefetch
        return

      case ActionType.GetTimeSpent: {
        return {
          ...state,
          timeSpent: action.timeSpent,
          isDailyGoalAchieved: action.timeSpent >= state.dailyGoal
        }
      }

      case UserServiceActionTypes.LOGOUT: {
        draft.shouldRefetchLibrary = true
        draft.libraryContent = libraryInitialState.libraryContent
        return
      }

      default:
        return state
    }
  })
